import { createContext, useCallback, useContext, useMemo, useState } from "react";

const MediosAudioContext = createContext(null);

/** Un solo canal con audio a la vez: hero | hub. */
export function MediosAudioProvider({ children }) {
  const [speaker, setSpeaker] = useState(null);

  const claim = useCallback((channel) => {
    if (!channel) return;
    setSpeaker(channel);
  }, []);

  const release = useCallback((channel) => {
    setSpeaker((prev) => (prev === channel ? null : prev));
  }, []);

  const value = useMemo(() => ({ speaker, claim, release }), [speaker, claim, release]);

  return <MediosAudioContext.Provider value={value}>{children}</MediosAudioContext.Provider>;
}

export function useMediosAudio(channel) {
  const ctx = useContext(MediosAudioContext);
  if (!ctx) {
    return {
      speaker: null,
      otherHasAudio: false,
      claim: () => {},
      release: () => {},
    };
  }
  return {
    speaker: ctx.speaker,
    otherHasAudio: Boolean(ctx.speaker && ctx.speaker !== channel),
    claim: () => ctx.claim(channel),
    release: () => ctx.release(channel),
  };
}
